<template>
    <div v-if="products.length" class="container-fluid associated-products">
        <h3 class="section-title mb-4">
            Вам может понравиться
        </h3>
        <ul class="nav nav-tab">
            <li class="nav-item" v-for="(title, tab) in tabs" v-if="hasAssociatedProducts(tab)">
                <span class="nav-link"
                   :class="{ active: isActive(tab) }"
                   @click.prevent="activeTab = tab">{{ title }}</span>
            </li>
        </ul>
        <div v-for="(title, tab) in tabs"
             v-if="hasAssociatedProducts(tab)"
             v-show="isActive(tab)">
            <product-carousel :classes="classes" v-if="products.length" :items="products"></product-carousel>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'AssociatedProducts',
        props: {
            classes: {
                type: String,
                default: () => ''
            }
        },
        data() {
            return {
                tabs: {
                    brand: 'Бренд',
                    category: 'Категория',
                    color: 'Цвет',
                },
                activeTab: 'brand',
            }
        },
        watch: {
            associatedProducts (val) {
                if (val) {
                    for (let tab in this.tabs) {
                        if (this.hasAssociatedProducts(tab)) {
                            this.activeTab = tab;
                            break;
                        }
                    }
                }
            }
        },
        methods: {
            isActive (tab) {
                return tab === this.activeTab;
            },
            hasAssociatedProducts (tab) {
                return this.productsIn(tab).length !== 0;
            },
            productsIn (tab) {
                const products = this.associatedProducts;
                return products[tab] ? products[tab] : [];
            }
        },
        computed: {
            ...mapState('product', [
                'associatedProducts',
            ]),
            products () {
                return this.productsIn(this.activeTab);
            }
        },
    }
</script>
